import { Component, Input, HostBinding, OnChanges, SimpleChange, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MaskApplierService, MaskPipe } from 'ngx-mask';
import { Subscription } from 'rxjs';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { AppLoadingService } from '../../services/apploading.service';
import { GeneralService } from '../../services/general.service';
import { RequestService } from '../../services/request.service';
import { Gallery } from '../../utils/gallery';

declare var $:any;

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnChanges, AfterViewInit, OnDestroy {

  dialogRef: MatDialogRef<any>;

  @Input() data: any = {};
  @Input() class: string = '';

  @HostBinding('className') className = this.class;

  menuActionActive = 'pending_requests';

  loading = true;

  error = false;

  params:any={};

  gallery:any = [];

  requestType:any = {};
  requestStatus:any = {};

  requestLoading = false;

  requestPage : any = 1;

  swiperPersonsConfig ={
    init:true,
    observer: true,
    observeParents: true,
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 10
  };

  protected transactionDataSubscription: Subscription;

  constructor(
    protected als: AppLoadingService,
    public dialog: MatDialog,
    protected httpService: HttpService,
    protected gs: GeneralService,
    protected ga : Gallery,
    protected ms : MaskApplierService,
    protected rs : RequestService
  ) {

    this.requestType = this.gs.getRequestTypes();
    this.requestStatus = this.gs.getRequestStatus();

    this.transactionDataSubscription = this.gs.transactionData.subscribe(result => {
      if(result?.method == 'request' && result?.action == 'reload'){
        this.requestLoad(null, 1);
      }
    });

  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if (changes?.active || changes?.apply)
      this.updateClassName();
  }

  updateClassName() {
    this.className = [this.class, this.data?.person_id ? 'active' : ''].join(' ');
  }

  ngOnDestroy(){
    this.transactionDataSubscription?.unsubscribe();
  }

  ngAfterViewInit() {
    if (!this.params?.public_idtext)
      return;

    this.loadProfile(this.params?.public_idtext);
  }

  async loadProfile(public_idtext, owner_person_id = null):Promise<any>{

    this.loading = true;

    await this.gs.loadProfile(public_idtext, owner_person_id)
      .then(result => {
        this.setData(result);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  setData(data){

    const mask = new MaskPipe(this.ms);

    this.data = data;
    
    if(this.data.creci_state_id)
      this.data.creci_state = this.gs.getStates(this.data.creci_state_id)[0] || {};

    this.data.avatarFiles = this.gs.getAvatarFile(this.data.avatar);
    
    this.data.companies = JSON.parse(this.data.companies).filter(item => item?.company_public_idtext != null).map(item=> {
      if(item.company_avatar_link)
        item.avatar = this.gs.getAvatarFile(item.company_avatar_link);

      return item;
    });

    if(this.data?.site?.length > 2 && this.data?.site?.indexOf('http') == -1)
      this.data.site = 'http://'+this.data.site;

    //if(this.data.pending_requests?.list){      this.data.pending_requests.list = this.adjustList(this.data.pending_requests?.list);    }

    if(this.data?.avatarFiles?.data){
      this.gallery = [{
        id: 1,
        src : this.data.avatarFiles.large,
        src_width : this.data.avatarFiles.data.width*3,
        src_height : this.data.avatarFiles.data.height*3,
        subHtml : this.data.name
      }];
      this.ga.setData({gallery : this.gallery}, null);
    }

    this.data.addressText = [(this.data?.street || '') + (this.data?.number ? ', n ' + this.data.number : '') + (this.data.complement ? ' ' + this.data.complement : ''), this.data?.district, this.data.city + (this.data?.stateAcronym? ' / ' + this.data?.stateAcronym : '')].filter(Boolean).join(' - ');
    if(typeof this.data.addressText == 'string' && this.data.addressText == 'null')
      this.data.addressText = null;

    this.data.address = {location : {lat:this.data.lat, lon:this.data.lon}};

    if(this.data?.phone)
      this.data.phonemask = mask.transform(this.data.phone.replace('+',''), this.gs.getPhoneMask(this.data.phone));

    if(this.data?.cellphone)
      this.data.cellphonemask = mask.transform(this.data.cellphone.replace('+',''), this.gs.getPhoneMask(this.data.cellphone));

    this.data.owner_person_id = this.gs.getCompanieSel();

    this.requestLoad(null, 1);
  }

  adjustList(list:any){
    let arr = list?.list || list;
    arr = arr.map(item=> {
      if(item?.ad_cover || item?.cover){
        item.cover = typeof item?.cover === 'string'? JSON.parse(item.cover) : (typeof item?.ad_cover === 'string'? JSON.parse(item.ad_cover) : (item?.ad_cover || item?.cover));          
        item.cover = this.gs.getAvatarFile(item.cover);
      }

      if(typeof item?.creator_avatar === 'string' && item?.creator_avatar!='{}')
        item.creatorFiles = this.gs.getAvatarFile(JSON.parse(item.creator_avatar));
      
      if(typeof item?.owner_avatar === 'string' && item?.owner_avatar!='{}')
        item.ownerFiles = this.gs.getAvatarFile((item.owner_avatar));

      return item;
    });

    if(list?.list)
      list.list = arr;
    else
      list = arr;

    return list;
  }

  setMenuAction(action){
    this.menuActionActive = action;
    this.requestLoad(null,1);
  }

  async requestLoad(event, page:any = 'next'){
    if(this.requestLoading)
      return;

    this.requestPage = page == 'next'? this.requestPage+1 : page;

    let endpoint:any = false;
    let data:any = {};

    switch(this.menuActionActive){
      case 'pending_requests':
        endpoint = API.person.general.request.pending;
        data = {
          owner_person_id: this.data?.owner_person_id,
          creator_public_idtext : this.params?.public_idtext
        };
      break;
      case 'restricted_access':
        endpoint = API.ad.general.restricted.listAllowedForPerson;
        data = {
          owner_person_id: this.data?.owner_person_id,
          public_idtext : this.params?.public_idtext
        };
      break;
      case 'authorization':
        endpoint = API.person.general.request.pending;
        data = {
          owner_person_id: this.data?.owner_person_id,
          public_idtext : this.params?.public_idtext
        };
      break;
      case 'print':
        endpoint = API.person.general.request.pending;
        data = {
          owner_person_id: this.data?.owner_person_id,
          public_idtext : this.params?.public_idtext
        };
      break;
    }

    if(!endpoint || !data?.owner_person_id){
      return;
    }

    this.error = false;
    this.requestLoading = true;
    
    //await this.gs.als.setLoaded(false,'companieRequestList');

    this.httpService.post<any>(endpoint, {...data, current_page: this.requestPage})
    .then(result => {
      this.data[this.menuActionActive] = result;//this.adjustList(result);
      
    })
    .catch((err) => {  
      
      this.data[this.menuActionActive] = { list: [], total:{}};

      this.error = true;
      this.gs.error(err); 
    })
    .finally(() => {
      if (event?.target)
        event?.target.complete();

      this.requestLoading = false;
      //this.gs.als.setLoaded(true,'companieRequestList');
    });

  }

  setRequestAction(event, data:any, type = null){
    if(type) 
      data.type_id = type;
    
    this.rs.setRequestAction(event, {...data,name: this.data.name, public_idtext: this.params?.public_idtext,  owner_person_id: this.data?.owner_person_id, admin : this.gs.getCompanieSel() || false}, {admin : this.gs.getCompanieSel()});
  }

  openImage(item){
    if(!item?.large)
      return;

    let image = {src:item.large, w:item.data.width*3, h: item.data.height*3, title:this.data.name};
    this.gs.openGallery([image]);
  }

  openProfile(ev, public_idtext){
    this.gs.openProfile(ev, public_idtext);
  }

  openMap(data: any) {
    if(data?.street)
      this.gs.openMap(data);
  }

  openOwnerPhones(event){
    event.stopPropagation();
    let obj = $(event.target);
    let phones = obj.parents('.mat-dialog-container').find('.phones');
    phones.css('left',obj.position().left).css('top',obj.offset().top+obj.height()+10).addClass('active');

    phones.off('mouseover').on('mouseover',function (ev) {
      $(this).addClass('over');
    });
    document.addEventListener("mousemove", this.closeOwnerPhones);
    document.addEventListener("click", this.closeOwnerPhones);

  }
  closeOwnerPhones(ev){
    if(((ev.type=='mousemove' && !!$('.phones.active.over')?.length) || ev.type=='click') && !$(ev.target).parents('.phones')?.length){
      $('.phones.active').removeClass('active').removeClass('over');
      document.removeEventListener('mousemove',this.closeOwnerPhones);
      document.removeEventListener('click',this.closeOwnerPhones);
    }        
  }

  getTemplate(id){
    return 'requestType'+id;
  }

  action(event, action, data){
    //DIEGO FAZER
  }
}
